var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Freewheel = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {

    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber].getPlayheadTime)
          return instances[adnumber].getPlayheadTime()
      }
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.slot) {
      var instances = this.slot.getAdInstances()
      if (instances) {
        var adnumber = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1
        if (instances[adnumber].getDuration)
          return instances[adnumber].getDuration()
      }
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    if (this.titles) {
      return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId
    }
    return "unknown"
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (this.player.videoEl && this.player.videoEl.currentSrc) {
      return this.player.videoEl.currentSrc
    }
    if (this.plugin.getAdapter()) {
      return this.plugin.getAdapter().getResource()
    }
    return null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return tv.freewheel.SDK.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Freewheel"
  },

  getPosition: function () {
    return this.position
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION_END] = this.endedListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION] = this.playListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_PAUSE] = this.pauseListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_RESUME] = this.resumeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_SKIPPED] = this.skipListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD] = this.logListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_STARTED] = this.slotListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_CLOSE] = this.closeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_ENDED] = this.closeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_CLICK] = this.clickListener.bind(this)

    //Errors
    this.references[tv.freewheel.SDK.ERROR_3P_COMPONENT] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_ADINSTANCE_UNAVAILABLE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_DEVICE_LIMIT] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_INVALID_SLOT] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_INVALID_VALUE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_IO] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_MISSING_PARAMETER] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_NO_AD_AVAILABLE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_NO_RENDERER] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_NULL_ASSET] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_PARSE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_SECURITY] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_TIMEOUT] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_UNKNOWN] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_UNMATCHED_SLOT_SIZE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_UNSUPPORTED_3P_FEATURE] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_COMPANION_GENERAL_ERROR] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_GENERAL_LINEAR_ERROR] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_GENERAL_VPAID_ERROR] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_LINEARITY_NOT_MATCH] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_NON_LINEAR_GENERAL_ERROR] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_NO_AD] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_SCHEMA_VALIDATION] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_TRACKING_ERROR] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_URI_TIMEOUT] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_VERSION_NOT_SUPPORTED] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_WRAPPER_LIMIT_REACH] = this.errorListener.bind(this)
    this.references[tv.freewheel.SDK.ERROR_VAST_XML_PARSING] = this.errorListener.bind(this)
    // Register listeners
    for (var key in this.references) {
      this.player.currentAdContext.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.currentAdContext.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  slotListener: function (e) {
    this.slot = e.slot
    var position = e.slot.getTimePositionClass()
    this.disable = false
    if (position === "POSTROLL") {
      this.position = "post"
    } else if (position === "MIDROLL") {
      this.position = "mid"
    } else if (position === "PREROLL") {
      this.position = "pre"
    } else {
      this.disable = true
    }
    if (!this.disable) {
      this.titles = e.slot.getAdInstances()
      if (this.plugin.getAdapter()) {
        this.plugin.getAdapter().unregisterListeners()
      }
      if (!this.plugin.isInitiated && !this.plugin.isStarted) {
        if (this.plugin.getAdapter()) {
          this.plugin.getAdapter().fireInit()
        } else {
          this.plugin.fireInit()
        }
      }
      //this.fireInit()
      //this.fireJoin()
    }
  },
  playListener: function (e) {
    if (this.disable) return null
    this.fireStart()
    this.fireJoin()
  },
  pauseListener: function (e) {
    this.firePause()
  },
  resumeListener: function (e) {
    this.playListener()
    this.fireResume()
  },
  endedListener: function (e) {
    this.fireStop()
  },
  skipListener: function (e) {
    this.fireStop({ skipped: true })
  },
  logListener: function (e) {
    if (e.errorCode || e.errorInfo || e.errorModule) {
      this.fireError(e.errorCode || e.errorInfo, e.errorInfo)
      this.fireStop()
    }
    if (e.subType === "_pause") {
      this.firePause()
    }
    if (e.subType === "_resume") {
      this.playListener()
      this.fireResume()
    }
    youbora.Log.debug(e.subType)
  },
  clickListener: function (e) {
    this.fireClick()
  },
  closeListener: function (e) {
    if (this.plugin.getAdapter()) {
      this.plugin.getAdapter().registerListeners()
    }
    if (this.position === "post" && !this.disable) {
      this.plugin.fireStop({ end: true })
    }
  },
  errorListener: function (e) {
    this.fireError(e.errorCode || e.subType, e.errorInfo)
    this.fireStop()
    if (this.plugin.getAdapter()) {
      this.plugin.getAdapter().registerListeners()
    }
  }
})

module.exports = youbora.adapters.Freewheel
